import { render } from "./LayoutDefault.vue?vue&type=template&id=4599f2db&ts=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=ts"
export * from "./LayoutDefault.vue?vue&type=script&lang=ts"

import "./LayoutDefault.vue?vue&type=style&index=0&id=4599f2db&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__